<template>
  <d-card class="mt-3">
    <d-collapse
      visible
      id="accordion1"
      accordion="my-accordion"
      v-for="(supplier, index) in supplies"
      v-if="index !== '0'"
      :key="index">
      <d-card-body style="padding: 1rem;">
        <span class="mr-2">{{supplier.supplier_name}}</span>
        <span
          :style="supplier.orders_count_with_payment === supplier.orders_count ?
          'color: #17c671; font-weight: 700;' : 'color: #007bff; font-weight: 700;'">
          {{supplier.orders_count}}</span>
        <d-button
          :ref="`button-supplies-${index}`"
          v-d-toggle="`snc-${index}`"
          :class="'collapse_button'"
          outline
          :theme="'light'">
          <i class="material-icons">keyboard_arrow_down</i>
        </d-button>
        <div class="orderCollapse">
          <d-collapse
            class="orderCollapse"
            :id="`snc-${index}`">
            <div
              class="p-3 mt-3 border"
              v-for="(orders, indexOrder) in supplier.orders"
              :key="indexOrder">
              <h3
                style="white-space: nowrap; opacity: 0.3"
                class="page-title mt-2 pb-3">
                {{orders.date.slice(8)}} {{orders.date.slice(5, 7) === '01' ? 'Styczeń' : (orders.date.slice(5, 7) === '02' ? 'Luty' : (orders.date.slice(5, 7) === '03' ? 'Marzec' : (orders.date.slice(5, 7) === '04' ? 'Kwiecień' :
                (orders.date.slice(5, 7) === '05' ? 'Maj' : (orders.date.slice(5, 7) === '06' ? 'Czerwiec' : (orders.date.slice(5, 7) === '07' ? 'Lipiec' : (orders.date.slice(5, 7) === '08' ? 'Sierpień' : (orders.date.slice(5, 7) === '09' ? 'Wrzesień' : (
                orders.date.slice(5, 7) === '10' ? 'Październik' : (orders.date.slice(5, 7) === '11' ? 'Listopad' : (orders.date.slice(5, 7) === '12' ? 'Grudzień' : '')))))))))))}}
                {{orders.date.slice(0, 4)}}
              </h3>
              <table class="table p-2 mb-0 full-width">
                <thead class="bg-light">
                  <tr>
                    <th
                      scope="col"
                      class="border-0">Odbiorca</th>
                    <th
                      scope="col"
                      class="border-0">Kwota</th>
                    <th
                      scope="col"
                      class="border-0 text-center">Kierowca</th>
                    <th
                      scope="col"
                      class="border-0 text-right">Produkty</th>
                    <th
                      scope="col"
                      class="border-0 text-right">Pudełka</th>
                  </tr>
                </thead>
                <tbody
                  style="border-top: 1px solid #dee2e6 !important;"
                  v-for="(order, indexOrder) in orders.orders"
                  :key="indexOrder">
                  <tr>
                    <td class="align-middle">
                      {{ order.customer_name}}
                      <span class="bottom-text">
                        <span
                          class="bottom-text-value"
                          style="opacity: 0.5"
                          v-if="order.shop_address && order.shop_post_code && order.shop_city">
                          {{ order.shop_address + ', ' + order.shop_post_code + ' ' + order.shop_city}}
                        </span>
                      </span>
                    </td>
                    <td class="align-middle collapse-nowrap">
                      <span :class="getOrderPriceClass(order)">
                        {{(order.payment_transferred + order.payment_cash  + order.payment_card).toFixed(2)}} / {{ order.price.toFixed(2) }} zł
                      </span>
                    </td>
                    <td class="align-middle text-center collapse-nowrap">
                      {{order.supplier_name}}
                    </td>
                    <td class="align-middle  text-right">
                      {{order.products_count}}
                    </td>
                    <td class="align-middle text-right">
                      {{order.containers_number}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </d-collapse>
        </div>
      </d-card-body>
    </d-collapse>
  </d-card>
</template>

<script>
export default {
  name: 'dashboard-collapse',
  data () {
    return {
      data: [],
    };
  },
  methods: {
    getOrderPriceClass (order) {
      if (order.payment_cash === 0 && order.payment_transferred === 0 && order.payment_card === 0) {
        return 'order-payments-red';
      }

      if (order.payment_cash !== 0) {
        if (order.payment_cash !== order.price) {
          return 'order-payments-blue';
        }

        return 'order-payments-green';
      }

      if (order.payment_transferred !== 0) {
        if (order.payment_transferred !== order.price) {
          return 'order-payments-blue';
        }

        return 'order-payments-green';
      }

      if (order.payment_card !== 0) {
        if (order.payment_card !== order.price) {
          return 'order-payments-blue';
        }

        return 'order-payments-green';
      }

      return 'order-payments-red';
    }
  },
  props: {
    supplies: {
      type: [Object, Array],
      required: true
    },
    refresh: {
      type: Function,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.sum-group {
  padding: 0 2rem 2rem 2rem;
  p {
    display: flex;
    margin: 0;
    font-weight: 200;
    padding-top: 0.5rem;
    span {
      font-weight: 600;
      margin-left: 0.5rem;
    }
  }
}
.collapse_button {
  width: 35px;
  height: 35px;
  margin-top: -0.2rem;
  margin-left: 1rem;
  padding: 0.5rem ;
  border: 1px solid #c8c8c8;
  border-radius: 40px;
  i {
    margin-left: 0.2rem;
  }
}

  .collapse-nowrap {
    white-space: nowrap;
  }
</style>

